// @ts-nocheck
import * as Types from '../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
export type FloorPlanOptionGroup_CheckoutOptionGroupFragment = { __typename?: 'CheckoutConfigOptionGroup', id: string, step: Types.CheckoutConfigOptionGroupStep, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, isSelected: boolean, option: { __typename?: 'ReadyPlanOption', id: string, code: string } }> };

export const FloorPlanOptionGroup_CheckoutOptionGroupFragmentDoc = gql`
    fragment FloorPlanOptionGroup_CheckoutOptionGroup on CheckoutConfigOptionGroup {
  id
  step
  options {
    id
    isSelected
    option {
      id
      code
    }
  }
}
    `;